import { render } from "./d.vue?vue&type=template&id=2be86ae6&lang=pug"
import script from "./d.vue?vue&type=script&lang=js"
export * from "./d.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__